$(function () {
  const desktopMenu = $('#desktop-menu');
  const desktopLogo = $('#desktop-logo');
  const primaryLogo = $('#primary-logo');
  const secondaryLogo = $('#secondary-logo');
  const displaySecondaryLogo = $(secondaryLogo).data('display-secondary-logo');
  const contactBtnWidth = $('#header-contact-button')?.width() ?? 0;
  const phoneNumberWidth = $('#header-phone-number')?.width() ?? 0;
  let desktopMenuWidth = desktopMenu.outerWidth();
  const animatedMenuItemUnderline = '.animated-menu-item-underline';
  const animatedMenuItem = '.animated-menu-item';
  const headerContainer = '#header-container';
  const headerFontColor = $(headerContainer).data('font-color');
  const headerFontHoverColor = $(headerContainer).data('font-hover-color');
  const transparentHeaderDisabled = $(headerContainer).data(
    'transparent-header-disabled'
  );
  const transparentHeaderFontColor = $(headerContainer).data(
    'transparent-font-color'
  );
  const transparentHeaderFontHoverColor = $(headerContainer).data(
    'transparent-font-hover-color'
  );
  const mainMenuItems = desktopMenu.children('li');

  const handleSolidBg = () => {
    $(headerContainer).removeClass(
      `v2-bg-transparent v2-text-${transparentHeaderFontColor}`
    );
    $(headerContainer).addClass(`v2-shadow v2-text-${headerFontColor}`);

    $(animatedMenuItemUnderline).addClass(`v2-bg-${headerFontHoverColor}`);
    $(animatedMenuItemUnderline).removeClass(
      `v2-bg-${transparentHeaderFontHoverColor}`
    );
  };

  const handleTransparentBg = () => {
    $(headerContainer).removeClass(`v2-shadow v2-text-${headerFontColor}`);
    $(headerContainer).addClass(
      `v2-bg-transparent v2-text-${transparentHeaderFontColor}`
    );
    $(animatedMenuItem).removeClass(`v2-text-${headerFontColor}`);
    $(animatedMenuItemUnderline).addClass(
      `v2-bg-${transparentHeaderFontHoverColor}`
    );
    $(animatedMenuItemUnderline).removeClass(`v2-bg-${headerFontHoverColor}`);
  };

  const handleSubMenu = () => {
    $(mainMenuItems).each(function (idx, menuItem) {
      $(menuItem).on('mouseenter', function () {
        $(menuItem).find('.dropdown-desktop-menu').addClass('v2-block');
        $(menuItem).find('.dropdown-desktop-menu').removeClass('v2-hidden');
      });

      $(menuItem).on('mouseleave', function () {
        $(menuItem).find('.dropdown-desktop-menu').removeClass('v2-block');
        $(menuItem).find('.dropdown-desktop-menu').addClass('v2-hidden');
      });

      let subMenuItems = $('.submenu-item', menuItem);

      $(subMenuItems).each(function (idx, subMenuItem) {
        $(subMenuItem).on('mouseenter', function () {
          $(subMenuItem)
            .find('.sub-dropdown-desktop-menu')
            .addClass('v2-block');
          $(subMenuItem)
            .find('.sub-dropdown-desktop-menu')
            .removeClass('v2-hidden');
        });

        $(subMenuItem).on('mouseleave', function () {
          $(subMenuItem)
            .find('.sub-dropdown-desktop-menu')
            .removeClass('v2-block');
          $(subMenuItem)
            .find('.sub-dropdown-desktop-menu')
            .addClass('v2-hidden');
        });
      });
    });
  };

  const handleMenuVisibility = () => {
    const newMenuWidth = desktopMenu.outerWidth();
    let headerContainerWidth = $(headerContainer).outerWidth();
    const logoWidth = desktopLogo.width();

    desktopMenuWidth =
      newMenuWidth > desktopMenuWidth ? newMenuWidth : desktopMenuWidth;

    let headerContainerPadding =
      $(headerContainer).innerWidth() - $(headerContainer).width();

    let availableSpace =
      headerContainerWidth -
      logoWidth -
      headerContainerPadding -
      contactBtnWidth -
      phoneNumberWidth;

    // Always display the hamburger menu and not the desktop menu at the 640px breakpoint
    if (headerContainerWidth <= 640) {
      $('#desktop-menu')
        .addClass('v2-hidden')
        .removeClass('v2-inline-flex v2-invisible');

      $('#hamburger-menu').removeClass('v2-invisible v2-hidden');
      return;
    } else {
      if (desktopMenuWidth > availableSpace) {
        $('#desktop-menu')
          .addClass('v2-hidden')
          .removeClass('v2-inline-flex v2-invisible');

        $('#hamburger-menu').removeClass('v2-hidden v2-invisible');
      } else {
        $('#desktop-menu')
          .removeClass('v2-hidden v2-invisible')
          .addClass('v2-inline-flex');

        $('#hamburger-menu').addClass('v2-hidden');
      }
    }
  };

  handleMenuVisibility();
  handleSubMenu();

  $(window).on('resize', handleMenuVisibility);

  if (transparentHeaderDisabled) {
    handleSolidBg();
  } else {
    $(window).on('scroll', function () {
      if ($(window).scrollTop() === 0) {
        handleTransparentBg();
      } else {
        handleSolidBg();
      }
    });
  }

  if (displaySecondaryLogo && transparentHeaderDisabled !== 1) {
    $(secondaryLogo).removeClass('v2-hidden');
    $(primaryLogo).addClass('v2-hidden');
    $(window).on('scroll', function () {
      if ($(window).scrollTop() === 0) {
        $(secondaryLogo).removeClass('v2-hidden');
        $(primaryLogo).addClass('v2-hidden');
      } else {
        $(primaryLogo).removeClass('v2-hidden');
        $(secondaryLogo).addClass('v2-hidden');
      }
    });
  }
});
